// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Loading3QuartersOutlinedSvg from "@fishx/icons-svg/es/asn/Loading3QuartersOutlined";
import FishxIcon from '../components/FishxIcon';

var Loading3QuartersOutlined = function Loading3QuartersOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Loading3QuartersOutlinedSvg
  }));
};

Loading3QuartersOutlined.displayName = 'Loading3QuartersOutlined';
export default React.forwardRef(Loading3QuartersOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Loading3QuartersOutlined.js
// module id = 3053
// module chunks = 0